import { SVGProps } from "react";

type HistogramProps = SVGProps<SVGSVGElement>;

export const Histogram = (props: HistogramProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clipPath="url(#clip0_6655_1375)">
      <path
        d="M3 18.3133C2.77899 18.3133 2.56702 18.2255 2.41074 18.0693C2.25446 17.913 2.16667 17.701 2.16667 17.48V0H0.5V17.48C0.5 18.143 0.763392 18.7789 1.23223 19.2478C1.70107 19.7166 2.33696 19.98 3 19.98H20.5V18.3133H3Z"
        fill="currentColor"
      />
      <path d="M6.33366 10H4.66699V15.8333H6.33366V10Z" fill="currentColor" />
      <path
        d="M10.4997 8.33301H8.83301V15.833H10.4997V8.33301Z"
        fill="currentColor"
      />
      <path d="M14.6667 10.833H13V15.833H14.6667V10.833Z" fill="currentColor" />
      <path d="M18.8337 7.5H17.167V15.8333H18.8337V7.5Z" fill="currentColor" />
      <path
        d="M9.66648 3.67831L13.8331 7.84497L20.2556 1.42247L19.0773 0.244141L13.8331 5.48831L9.66648 1.32164L4.91064 6.07747L6.08898 7.25581L9.66648 3.67831Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6655_1375">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
